export const DEFAULT_SLOT_KEY = 'slot_0';
